var render = function render(){var _vm=this,_c=_vm._self._c;return _c('dv-border-box-8',{staticClass:"organ",attrs:{"dur":4,"backgroundColor":"rgba(8, 50, 78, 0.6)"}},[_c('PartTitle',{attrs:{"title":"明星企业"}}),_c('dv-scroll-board',{staticClass:"scroll-board",attrs:{"config":_vm.scrollBoardConfig}}),_c('div',{staticStyle:{"height":"10px"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }